// src/components/common/IconBoxOpen.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen } from '@/icons';
import './IconBoxOpen.css';

interface IconBoxOpenProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const IconBoxOpen: React.FC<IconBoxOpenProps> = ({
  onClick,
  title,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      className={`icon-box-open-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faBoxOpen} />
    </button>
  );
};

export default IconBoxOpen;
